import { marginBalanceKeys } from 'app/(trade)/queries/marginBalance';
import { getQueryClient } from 'app/get-query-client';
import { depositsKeys } from 'queries/deposits';
import { intraExchangeTransfersKeys } from 'queries/intraExchangeTransfers';
import { newUserChecklistKeys } from 'queries/newUserChecklist';
import { paymentsMetadataKeys } from 'queries/paymentsMetadata';
import { withdrawalLimitsKeys } from 'queries/withdrawalLimits';
import { invalidatePredictionsBalanceQueries } from 'utils/invalidatePredictionsBalanceQueries';

/** Refresh event-contract, perps, transfer, and funding balance state. */
export function invalidateAllBalanceQueries(qc = getQueryClient()) {
    invalidatePredictionsBalanceQueries(qc);
    qc.invalidateQueries({ queryKey: marginBalanceKeys.all });
    qc.invalidateQueries({ queryKey: intraExchangeTransfersKeys.all });
    qc.invalidateQueries({ queryKey: depositsKeys.all });
    // The checklist's deposit step is server-computed off the same funding state.
    qc.invalidateQueries({ queryKey: newUserChecklistKeys.all });
    qc.invalidateQueries({ queryKey: paymentsMetadataKeys.all });
    qc.invalidateQueries({ queryKey: withdrawalLimitsKeys.all });
}
